import React from 'react';

import { noop } from 'lodash';

import IconButton from '~/core/atoms/Buttons/IconButton';
import CaretIcon from '~/core/iconComponents/icons/CaretIcon';
import { direction } from '~/core/iconComponents/types';

interface ArrowButtonProps {
  /**
   * Size of the arrow icon
   */
  size?: number;
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;
  /**
   * Direction of the arrow ('left' or 'right')
   */
  direction?: direction;
  /**
   * Click handler for the button
   */
  onClick?: () => void;
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({
  size = 18,
  disabled = false,
  direction = 'right',
  onClick = noop,
}) => {
  return (
    <IconButton size="sm" onClick={onClick} disabled={disabled} className="rounded-full">
      <CaretIcon className="text-slate-800" size={size} direction={direction} />
    </IconButton>
  );
};
